export default "__VITE_ASSET__c68a4467__"